import React from 'react';
import { SingleDatePicker } from '@spothero/search-component';
import { Box, Icon, Popover, PopoverContent, PopoverTrigger, useDisclosure, Button, Text, } from '@spothero/ui';
import IconCalendar from '@spothero/icons/calendar';
export const FilterDateCalendar = ({ date, setDate }) => {
    const { onOpen: onPopoverOpen, onClose: onPopoverClose, isOpen: isPopoverOpen, } = useDisclosure();
    const handleCloseCalendar = newDate => {
        setDate(newDate);
        onPopoverClose();
    };
    return (<Box as="span" sx={{
            '.chakra-popover__popper': {
                zIndex: '1',
            },
        }} flex="1" display="flex">
            <Popover isOpen={isPopoverOpen} onOpen={onPopoverOpen} onClose={onPopoverClose} backgroundColor="white" variant="light">
                <PopoverTrigger>
                    <Button variant="tertiary" onClick={onPopoverOpen} padding="4" border="1px solid" borderColor="gray.200" borderRadius="0.5rem" color={date ? 'black' : 'gray.200'} textTransform="none" flex="1" justifyContent="flex-start" _hover={{
            color: 'gray.200',
        }}>
                        <Icon fill="black" as={IconCalendar} marginRight="4"/>
                        <Text as="span" data-testid="FilterDateCalendar-text">
                            {date
            ? date.toDateString()
            : 'Search by event date'}
                        </Text>
                    </Button>
                </PopoverTrigger>

                <PopoverContent hideCloseButton>
                    <Box zIndex={'layer1'}>
                        <SingleDatePicker date={date} setDate={handleCloseCalendar}/>
                    </Box>
                </PopoverContent>
            </Popover>
        </Box>);
};
